/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GoodIlsReportDto } from '../../models/good-ils-report-dto';

export interface GoodIlsControllerGetReport$Params {
}

export function goodIlsControllerGetReport(http: HttpClient, rootUrl: string, params?: GoodIlsControllerGetReport$Params, context?: HttpContext): Observable<StrictHttpResponse<GoodIlsReportDto>> {
  const rb = new RequestBuilder(rootUrl, goodIlsControllerGetReport.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GoodIlsReportDto>;
    })
  );
}

goodIlsControllerGetReport.PATH = '/good-ils/report';
